import { ErrorCode, ErrorTexts } from "types/error";

/**
 * エラーコードを付与してエラーページへ遷移させる
 * @param {ErrorCode} code
 * @param {number} [httpStatusCode]
 */
export const handleMoveToErrorPage = (
  code: ErrorCode,
  httpStatusCode?: number
) => {
  window.location.replace(
    `/error?error_code=${code}&http_status_code=${httpStatusCode ?? ""}`
  );
};

/**
 * エラーページに表示するタイトルと説明文を取得
 * @param {string} paramStr
 * @return {ErrorTexts}
 */
export const getErrorTexts = (paramStr: string): ErrorTexts => {
  const searchParams = new URLSearchParams(paramStr);
  const errorCode = searchParams.get("error_code") as ErrorCode;
  const httpStatusCode = searchParams.get("http_status_code");

  switch (errorCode) {
    case "server-error":
      return {
        title: "サーバーエラー",
        description: `サーバー側でエラーが発生しました。\r\nアプリを再起動してください。${
          httpStatusCode ? `（status: ${httpStatusCode}）` : ""
        }`,
      };
    case "session-expired":
      return {
        title: "セッションの有効期限切れ",
        description:
          "セッションの有効期限が切れています。\r\nアプリを再起動してください。",
      };
    case "init-liff-failure":
      return {
        title: "起動失敗",
        description: "アプリの起動に失敗しました。",
      };
    default:
      return {
        title: "エラー",
        description: "エラーが発生しました。",
      };
  }
};
